import { apiClient } from "./ApiClient";

export default {
  list() {
    return apiClient.get(`/api/user`);
  },
  delete(id) {
    return apiClient.delete(`/api/user/${id}`);
  },
  add(user) {
    return apiClient.post(`/api/user`, user);
  },
  save(user) {
    return apiClient.put(`/api/user/${user.id}`, user);
  },
  login(username, password) {
    return apiClient.post(`/api/user/login`, { username, password });
  },
  saveFolders(folders) {
    return apiClient.post(`/api/user/boards/folders`, folders);
  },
  getFolders() {
    return apiClient.get(`/api/user/boards/folders`);
  }
};
